<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Edit Event Instructors</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <app-edit-event-instructors [instructors]="instructors"
                                  [useIsSub]="true"
                                  [id]="'editInstructors'"></app-edit-event-instructors>
    </div>

    <div *ngIf="eventPart.schedule_id !== null" class="alert alert-info">
      This event belongs to a
      <span *ngIf="eventPart.schedule_name">schedule, "{{ eventPart.schedule_name }}".</span>
      <span *ngIf="!eventPart.schedule_name">schedule.</span>
      Modifying the event's instructors here will only affect this particular event. If you want to modify the instructors for the entire schedule, you may do so in the
      <a [routerLink]="['/events/setup/edit', eventPart.event_type_id, 'schedules', eventPart.schedule_id]"
         (click)="activeModal.dismiss()">
        schedule's edit page
      </a>.
      <br><br>
      If you edit the event's instructors here, any future changes to the schedule's instructors will not be reflected in this event.
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            (click)="handleSave()"
            [disabled]="loadingSave"
            [class.disabled]="loadingSave">
      {{ loadingSave ? 'Loading...' : 'Save' }}
    </button>
  </div>

</ng-container>
